import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../i18n';
import './styles.scss';

const DescriptionBlock = ({ description, className }) => {
  return (
    <div className={classNames('specific-course-screen__description', className)}>
      <h2>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.OVERVIEW.DESCRIPTION_TITLE')}</h2>
      <p dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default DescriptionBlock;
